import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';
import {
  PromotionalCodeSetActionPayload,
  TemporaryPromotionForOperatorSetActionPayload,
} from './actionPayload.interfaces';

export const PromotionalCodeActions = {
  setPromotionalCode: (payload: PromotionalCodeSetActionPayload) =>
    createAction(ActionType.SET_PROMOTIONAL_CODE, payload),
  setTemporaryPromotionForOperator: (
    payload: TemporaryPromotionForOperatorSetActionPayload
  ) => createAction(ActionType.SET_TEMPORARY_PROMOTION_FOR_OPERATOR, payload),
  clearTemporaryPromotionForOperator: () =>
    createAction(ActionType.CLEAR_TEMPORARY_PROMOTION_FOR_OPERATOR),
};

export type PromotionalCodeActionsType = ActionsUnion<
  typeof PromotionalCodeActions
>;
